import React, { Suspense, useMemo, useState, useEffect, useRef } from 'react'
import { addSitesToGroup, getAllSitesAPI, getDashboardStatsByGroup, getGroupSites, getGroupStats } from '../../Api Methods/Api';
import { Await, defer, Outlet, useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import classes from './GroupSites.module.css'
import FilterUsersDeviceSearch from '../../components/PowerSearch/FilterUsersDeviceSearch';
import Oval from 'react-loading-icons/dist/esm/components/oval';
import DevicesGrid from '../../components/GridList/DevicesGrid';
import DataManager from '../../hooks/DataManager';
import Button1 from '../../components/UI/Button/Button1';
import Modal from '../../components/Modal/Modal';
import DropDownForm from '../../components/forms/DropdownCreateGroup';
import DevicesList from '../../components/GridList/DevicesList';
import StatsContainer from './StatsContainer';
import Stats2 from '../../components/UI/Stats/Stats2';
import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import CategoryFilter from '../../components/PowerSearch/CategoryFilter';
import { filter } from 'rxjs';
import DeviceLoadingGrid from '../../components/GridList/DeviceLoadingGrid';
import { act } from 'react';
import { serviceActions } from '../../store/service-Slice';
import AllSitesSearchBar from '../AllSites/allSitesSearchBar';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import Lottie from 'lottie-react';
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import { Dialog } from 'primereact/dialog';

const GroupSites = () => {

    const [groupSites, setGroupSites] = useState([]);
    const [groupDashboardStats, setGroupDashboardStats] = useState();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const [isloading, setIsLoading] = useState(false);
    const [isLoadingSites, setIsLoadingSites] = useState(true)
    const [groupMode, setGroupMode] = useState(false);
    const dataManager = new DataManager();
    const groupName = sessionStorage.getItem('groupClicked');
    const groupPath = sessionStorage.getItem('groupPath');
    const groupPathToDisplay = groupPath.replace(/>/g, '  |  ');
    const groupID = sessionStorage.getItem('groupClickedID');
    const navigate = useNavigate();
    const apiData = {
        token,
        client
    }
    const dispatch = useDispatch();

    const [buttonText, setButtonText] = useState('Edit sites')
    const checkedItems = useState(dataManager.selectedSites.value || []);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [modalComponent, setModalComponent] = useState();
    const [title, setTitle] = useState('');
    const [showMassSettings, setShowMassSettings] = useState(false)

    const [removeVisible, setRemoveVisible] = useState(false)
    const [successVisible, setSuccessVisible] = useState(false)
    const [failVisible, setFailVisible] = useState(false)

    const groups = JSON.parse(localStorage.getItem('groups'));

    const [filteredData, setFilteredData] = useState([]) //Will be from cache eventually
    const service = useSelector(state => state.service);

    //Filters
    const [active, setActive] = useState(service.active)
    const [online, setOnline] = useState(service.online)
    const [offline, setOffline] = useState(service.offline)
    const [deviceTag, setDeviceTag] = useState(service.deviceTag)
    const [cloudController, setCloudController] = useState(service.cloudController)
    const [davantis, setDavantis] = useState(service.davantis)
    const [g2cc, setG2cc] = useState(service.g2cc)
    const [ESP, setESP] = useState(service.ESP)
    const [RPi, setRPi] = useState(service.RPi)
    const [groupName2, setGroupName2] = useState(groupName)
    const [includeSubgroups, setIncludeSubgroups] = useState(service.includeSubgroups)
    const [noTag, setNoTag] = useState(service.noTag)
    const [searchTerm, setSearchTerm] = useState(service.searchTerm)
    const [noUsers, setNoUsers] = useState(service.noUsers)
    const [liveViewStatus, setLiveViewStatus] = useState(service.liveViewStatus)
    const [scheduleOnly, setScheduleOnly] = useState(service.scheduleOnly)
    const [hasAjax, setHasAjax] = useState(service.hasAjax)
    const [hasHik, setHasHik] = useState(service.hasHik)
    const [hasAIBOX, setHasAIBOX] = useState(service.hasAIBOX)
    const [hasDahua, setHasDahua] = useState(service.hasDahua)
    const [hasPadlock, setHasPadlock] = useState(service.hasPadlock)
    const [hasKeybox, setHasKeybox] = useState(service.hasKeybox)
    const [hasGateway, setHasGateway] = useState(service.hasGateway)
    const [hasSigfox, setHasSigfox] = useState(service.hasSigfox)
    const [hasIndSigfox, setHasIndSigfox] = useState(service.hasIndSigfox)
    const [hasEfento, setHasEfento] = useState(service.hasEfento)
    const [hasSchedules, setHasSchedules] = useState(service.hasSchedules)
    const [hasTempSchedules, setHasTempSchedules] = useState(service.hasTempSchedules)
    const [activePinCount, setActivePinCount] = useState(service.activePinCount)

    //Sorts
    const [sortAsc, setSortAsc] = useState(service.sortAsc) //descending
    const [sUserCount, setSUserCount] = useState(service.sUserCount)
    const [sCreated, setSCreated] = useState(service.sCreated) //active by default
    const [sFirmware, setSFirmware] = useState(service.sFirmware)
    const [sName, setSName] = useState(service.sName)
    const [sCameraCount, setSCameraCount] = useState(service.sCameraCount)

    const [totalPages, setTotalPages] = useState([])
    const [resultCount, setResultCount] = useState(0)
    const [totalDevices, setTotalDevices] = useState([])
    const [pageOffset, setPageOffset] = useState(0)
    const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
    const [pageSize, setPageSize] = useState(dataManager.getItem('pageSize'))
    const [update, setUpdate] = useState(0)
    const [submit, setSubmit] = useState(0)

    const HandleShowModal = () => {
        ModalDialog.current.open();
    };

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    };

    useEffect(() => {

        const offset = pageSize * (pageFetchedIndex - 1);
        setPageOffset(offset);

        console.log("Offset:", offset);

        let body = {
            "active": Number(active),
            "pageSize": Number(pageSize),
            "pageOffset": Number(offset),
            "online": Number(online),
            "offline": Number(offline),
            "deviceTag": deviceTag,
            "cloudController": Number(cloudController),
            "davantis": Number(davantis),
            "g2cc": Number(g2cc),
            "ESP": Number(ESP),
            "RPi": Number(RPi),
            "groupName": groupName,
            "includeSubgroups": 1,
            "noTag": Number(noTag),
            "searchTerm": searchTerm,
            "noUsers": Number(noUsers),
            "liveViewStatus": Number(liveViewStatus),
            "scheduleOnly": Number(scheduleOnly),
            "hasAjax": Number(hasAjax),
            "hasHik": Number(hasHik),
            "hasAIBOX": Number(hasAIBOX),
            "hasDahua": Number(hasDahua),
            "hasPadlock": Number(hasPadlock),
            "hasKeybox": Number(hasKeybox),
            "hasGateway": Number(hasGateway),
            "hasSigfox": Number(hasSigfox),
            "hasIndSigfox": Number(hasIndSigfox),
            "hasEfento": Number(hasEfento),
            "hasSchedules": Number(hasSchedules),
            "hasTempSchedules": Number(hasTempSchedules),
            "activePinCount": Number(activePinCount),
            "sortAsc": Number(sortAsc),
            "sUserCount": Number(sUserCount),
            "sCreated": Number(sCreated),
            "sFirmware": Number(sFirmware),
            "sName": Number(sName),
            "sCameraCount": Number(sCameraCount)
        }

        console.log(body)

        HandleGetGroupSites(body)
        
    }, [submit, pageSize, pageFetchedIndex, online, offline, deviceTag, cloudController, davantis, g2cc, ESP, RPi, groupName, includeSubgroups, noTag, active, noUsers, liveViewStatus, scheduleOnly, hasAjax, hasHik, hasAIBOX, hasDahua, hasPadlock, hasKeybox, hasSigfox, hasIndSigfox, hasEfento, hasSchedules, activePinCount, sortAsc, sUserCount, sCreated, sFirmware, sName, sCameraCount])

    useEffect(() => {
        const delay = setTimeout(() => {
            setSubmit(prev => !prev);
        }, 700);

        //store it to reuse later
        dispatch(serviceActions.setSearchTerm(searchTerm))

        return () => clearTimeout(delay);
    }, [searchTerm]);



    const successModal = () => {
        setTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <img className={classes.ModalIcon} src={check}>
                </img>
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>Action completed successfully</h3>
                </div>
                <br></br>
                <br></br>
                <div>
                    <br></br>
                    <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
                </div>
            </div>
        )
        HandleShowModal();
    }

    const ModalDialog = useRef();

    const location = useLocation();
    const isGroupUsersPage = location.pathname.includes('GroupUsers'); // Check if on GroupUsers page

    let data;
    let statsData;

    useEffect(() => {
        const subscription = dataManager.selectedSites.subscribe((sites) => {
            setButtonText(sites.length > 0 ? 'Choose group' : 'Cancel');
        });

        return () => subscription.unsubscribe();
    }, []);

    const HandleGetGroupSites = async (body) => {
        setIsLoadingSites(true)
        const response = await getAllSitesAPI(apiData, body, dispatch)
        console.log(response.data)
        setResultCount(response.data[0][0].totalCount)
        setFilteredData(response.data[1])
        setTotalPages(Math.ceil(response.data[0][0].totalCount / pageSize));
        setIsLoadingSites(false)
    };


    const HandleGetGroupDashboard = async () => {
        let body = {
            "groupName": groupName
        }

        const response = await getDashboardStatsByGroup(apiData, body, dispatch)
        console.log(response.data[0][0])
        setGroupDashboardStats(response.data[0][0])
    }

    useEffect(() => {
        HandleGetGroupDashboard()
    }, []);

    const addSites = () => {
        dataManager.setItem('isGroupMode', true);
        navigate('/Dashboard/AllSites/');
    }

    const transferSites = async () => {
        console.log(selectedGroup)
       
        let body = {
            groupID: selectedGroup.id,
            groupName: selectedGroup.name,
            groupDevices: dataManager.selectedSites.value,
        }

        console.log(body)

        const response = await addSitesToGroup(apiData, body, dispatch);
        console.log(response)
        if (response.success) {
            setRemoveVisible(false)
            setSuccessVisible(true)
            dataManager.setItem('isGroupMode', false);
            dataManager.setSelectedSites([]);
            setGroupMode(false);
            HandleGetGroupDashboard();
            setSubmit(prev => !prev);
        } else {
            setFailVisible(true)
        }
        
    }

    const editSites = () => {
        dataManager.setItem('isGroupMode', !groupMode);
        setGroupMode(!groupMode);

        if (buttonText == "Choose group") {
            setRemoveVisible(true)
        }
    }

    useEffect(() => {
        if (groupMode) {
            if (dataManager.getItem('selectedSites').length > 0) {
                setButtonText('Choose group')
            } else {
                setButtonText('Cancel')
            }
        } else {
            setButtonText('Edit sites')
        }
    }, [groupMode, checkedItems])

    const viewUsers = () => {
        navigate('/Dashboard/Groups/GroupSites/GroupUsers/');
    }

    return (
        <>
            <Modal ref={ModalDialog} title={title} modalName={""} HandleShowModal={HandleShowModal}>
                {modalComponent}
            </Modal>

           <Dialog
                header="Remove sites"
                visible={removeVisible}
                style={{ width: "40vw" }}
                onHide={() => setRemoveVisible(false)}
                >
                <div>
                    <p>Choose the new group from the dropdown below</p>
                    <Dropdown
                        value={selectedGroup}
                        className="w-full md:w-14rem"
                        style={{ width: '400px' }}
                        onChange={(e) => setSelectedGroup(e.value)}  // e.value is FULL group object
                        options={groups}
                        optionLabel="name"
                        placeholder="Choose group"
                        showClear
                        filter
                        filterPlaceholder="Search groups..."
                    />

    
                </div>
    
                <br></br>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button label="Remove sites" severity="danger" disabled={!selectedGroup} onClick={transferSites} />
                </div>
            </Dialog>

            <Dialog
                header="Success"
                visible={successVisible}
                style={{ width: "40vw" }}
                onHide={() => setSuccessVisible(false)}
                >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <h3 style={{color:"#6e6e6eff"}}>Action completed successfully!.</h3>
                    <Lottie
                        animationData={successAnim}
                        loop={false}
                        style={{ width: 250, height: 250, margin: "0px" }}
                    />

                    <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setSuccessVisible(false)}/>
                </div>
            </Dialog>

            <Dialog
                header="Something went wrong"
                visible={failVisible}
                style={{ width: "40vw" }}
                onHide={() => setFailVisible(false)}
                >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={failAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br/>
                    <h3 style={{color:"#6e6e6eff"}}>Something went wrong, please try again</h3>
                    <br></br>
                    <Button label="Okay" rounded severity="secondary" onClick={() => setFailVisible(false)}/>
                </div>
            </Dialog>

            <div className={classes['activtyPage_container']}>
                <div style={{ marginLeft: "3px", color: "#7f7f7f" }}>
                    <h2>{groupName}</h2>
                    <p>{groupPathToDisplay}</p>
                </div>

                <Await resolve={groupDashboardStats}>
                    {(loadedStats) => (
                        <div className={classes.container}>
                            {groupDashboardStats && <Stats2 title={"All sites"} value={loadedStats.sitesCount} isLoadingStats={isloading} isStatic={true} />}
                            {groupDashboardStats && <Stats2 title={"Online sites"} value={(loadedStats.sitesCount - loadedStats.offlineCount)} isLoadingStats={isloading} isStatic={true} />}
                            {groupDashboardStats && <Stats2 title={"Active sites"} value={loadedStats.activeCount} isLoadingStats={isloading} isStatic={true} />}
                            {groupDashboardStats && <Stats2 title={"Inactive sites"} value={loadedStats.inactiveCount} isLoadingStats={isloading} isStatic={true} />}
                            {groupDashboardStats && <Stats2 title={"Controllers"} value={loadedStats.controllerCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeControllerCount} />}
                            {groupDashboardStats && <Stats2 title={"Offline controllers"} value={loadedStats.offlineCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.offlineActiveCount} />}
                            {groupDashboardStats && <Stats2 title={"Sites on schedule"} value={loadedStats.scheduleCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeScheduleCount} />}
                            {groupDashboardStats && <Stats2 title={"Users"} value={loadedStats.totalUserCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeTotalUserCount} />}
                            {groupDashboardStats && <Stats2 title={"Groups"} value={loadedStats.accountsCount} isLoadingStats={isloading} isStatic={true} />}
                            {groupDashboardStats && <Stats2 title={"Padlocks"} value={loadedStats.lockCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeLockCount} />}
                            {groupDashboardStats && <Stats2 title={"Billable padlocks"} value={loadedStats.billedLockCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={false} />}
                            {groupDashboardStats && <Stats2 title={"Keyboxes"} value={loadedStats.keyboxCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeKeyboxCount} />}
                            {groupDashboardStats && <Stats2 title={"Billable keyboxes"} value={loadedStats.billedKeyboxCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={false} />}
                            {groupDashboardStats && <Stats2 title={"Sensors"} value={loadedStats.sensorCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeSensorCount} />}
                            {groupDashboardStats && <Stats2 title={"Gateways"} value={loadedStats.gatewayCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeGatewayCount} />}
                            {groupDashboardStats && <Stats2 title={"Total integrations"} value={loadedStats.totalIntegrations} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.totalActiveIntegrations} />}
                            {groupDashboardStats && <Stats2 title={"AJAX"} value={loadedStats.ajaxCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeAjaxCount} />}
                            {groupDashboardStats && <Stats2 title={"Dahua"} value={loadedStats.dahuaCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeDahuaCount} />}
                            {groupDashboardStats && <Stats2 title={"Hikvision"} value={loadedStats.hikvisionCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeHikvisionCount} />}
                            {groupDashboardStats && <Stats2 title={"AIBox"} value={loadedStats.aiboxCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={true} value2={loadedStats.activeAiboxCount} />}
                            {groupDashboardStats && <Stats2 title={"Live view sites"} value={loadedStats.liveViewSitesCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={false} value2={loadedStats.liveViewSitesCount} />}
                            {groupDashboardStats && <Stats2 title={"Linked cameras"} value={loadedStats.linkedCamerasCount} isLoadingStats={isloading} isStatic={true} hasSecondValue={false} value2={loadedStats.linkedCamerasCount} />}

                        </div>
                    )}
                </Await>


                {!isGroupUsersPage && (
                    <>
                        {/* {groupSites && <FilterUsersDeviceSearch Devices={groupSites} searchQuery={searchQuery} setSearchQuery={setSearchQuery} placeholder={"Search Sites..."} setIsLoading={setIsLoading} setFilteredResults={setGroupSites} handleFilterLogic={handleFilterLogic} categories={["Online", "Offline", "Notifications On", "Notifications Off", "Favorited", "Not Favorited"]} />} */}
                        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "15px" }}>

                            {groupSites &&
                                <>
                                    <AllSitesSearchBar
                                        type="text"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        showFilterButton={true}
                                        groups={[]}
                                        includeSubgroups={includeSubgroups}
                                        setIncludeSubgroups={setIncludeSubgroups}
                                        online={online}
                                        setOnline={setOnline}
                                        offline={offline}
                                        setOffline={setOffline}
                                        deviceTag={deviceTag}
                                        setDeviceTag={setDeviceTag}
                                        cloudController={cloudController}
                                        setCloudController={setCloudController}
                                        davantis={davantis}
                                        setDavantis={setDavantis}
                                        G2CC={g2cc}
                                        setG2CC={setG2cc}
                                        ESP={ESP}
                                        setESP={setESP}
                                        RPi={RPi}
                                        setRPi={setRPi}
                                        groupName={groupName2}
                                        setGroupName={setGroupName2}
                                        submit={submit}
                                        setSubmit={setSubmit}
                                        noTag={noTag}
                                        setNoTag={setNoTag}
                                        noUsers={noUsers}
                                        setNoUsers={setNoUsers}
                                        liveViewStatus={liveViewStatus}
                                        setLiveViewStatus={setLiveViewStatus}
                                        hasAjax={hasAjax}
                                        setHasAjax={setHasAjax}
                                        hasHik={hasHik}
                                        setHasHik={setHasHik}
                                        hasAIBOX={hasAIBOX}
                                        setHasAIBOX={setHasAIBOX}
                                        hasDahua={hasDahua}
                                        setHasDahua={setHasDahua}
                                        active={active}
                                        setActive={setActive}
                                        hasPadlock={hasPadlock}
                                        setHasPadlock={setHasPadlock}
                                        hasKeybox={hasKeybox}
                                        setHasKeybox={setHasKeybox}
                                        hasGateway={hasGateway}
                                        setHasGateway={setHasGateway}
                                        hasSigfox={hasSigfox}
                                        setHasSigfox={setHasSigfox}
                                        hasIndSigfox={hasIndSigfox}
                                        setHasIndSigfox={setHasIndSigfox}
                                        hasEfento={hasEfento}
                                        setHasEfento={setHasEfento}
                                        hasSchedule={hasSchedules}
                                        setHasSchedule={setHasSchedules}
                                        hasTempSchedules={hasTempSchedules}
                                        setHasTempSchedules={setHasTempSchedules}
                                        activePinCount={activePinCount}
                                        setActivePinCount={setActivePinCount}
                                        sortAsc={sortAsc}
                                        setSortAsc={setSortAsc}
                                        sUserCount={sUserCount}
                                        setSUserCount={setSUserCount}
                                        sCreated={sCreated}
                                        setSCreated={setSCreated}
                                        sFirmware={sFirmware}
                                        setSFirmware={setSFirmware}
                                        sName={sName}
                                        setSName={setSName}
                                        sCameraCount={sCameraCount}
                                        setSCameraCount={setSCameraCount}
                                        isGroupSites={true}
                                        style={{
                                            padding: "10px",
                                            width: "300px",
                                            fontSize: "14px",
                                            boxSizing: "border-box",
                                            borderRadius: "4px",
                                        }}
                                    />

                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <Button severity='success' label="Add sites" onClick={addSites} icon="pi pi-plus" style={{ fontSize: "14px", padding: 10 }} />
                                        <Button severity='danger' label={buttonText} onClick={editSites} icon="pi pi-times" style={{ fontSize: "14px", padding: 10 }} />
                                        <Button severity="info" label="View portal users" icon="pi pi-user" onClick={viewUsers} style={{ fontSize: "14px", padding: 10 }} />
                                    </div>
                                </>
                            }
                        </div>



                        <div style={{ display: "flex", width: "100%", height: "10%", alignItems: "center" }}>
                            <p>Total results: {resultCount}</p>
                        </div>

                        <Await resolve={filteredData}>
                            {(loadedFilteredData) => (
                                <div style={{ display: "flex", width: "100%", height: "100%" }}>
                                    {isLoadingSites ? (
                                        <div style={{ display: "flex", width: "100%" }}>
                                            <DeviceLoadingGrid
                                                CardCount={20}
                                            />
                                        </div>
                                    ) : (
                                        <DevicesList
                                            devices={loadedFilteredData}
                                            filtering={""}
                                            hideControls={false}
                                            totalPages={totalPages}
                                            setTotalPages={setTotalPages}
                                            pageFetchedIndex={pageFetchedIndex}
                                            setPageFetchedIndex={setPageFetchedIndex}
                                            pageSize={pageSize}
                                            setPageSize={setPageSize}
                                            totalDevices={resultCount}
                                            setTotalDevices={setTotalDevices}
                                            groupMode={groupMode}
                                            update={update}
                                            setUpdate={setUpdate}
                                            offlineOnly={false}
                                            isSortable={true}
                                            showMassSelect={true}
                                            showMassSettings={showMassSettings}
                                            setShowMassSettings={setShowMassSettings}
                                        />
                                    )
                                    }
                                </div>
                            )}
                        </Await>

                    </>
                )}
                <Outlet />
            </div>
        </>
    )
}

export default GroupSites

export async function loader() {
    const token = localStorage.getItem('token');
    const client = localStorage.getItem('client');
    const apiData = {
        token,
        client
    }

    return defer({
        groupSites: getGroupSites(apiData, "EyeSpyFX")
    })
}